module.exports = __webpack_public_path__ + "img/error-v2.9ad41c6.png";